<template>
  <div :class="getClassName()">
    {{ text }}
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String
    },
    color: {
      type: 'systemred' | 'secondary',
      default: 'secondary'
    }
  },
  methods: {
    getClassName () {
      let result = 'coupon_label_container body_10_M'
      switch (this.color) {
        case 'syetemred':
          result = result + ` coupon_label_systemred f_red_1`
          break
        default:
          result = result + ` coupon_label_secondary f_secondary_3`
          break
      }
      return result
    }
  }
}
</script>

<style scoped>
.coupon_label_container {
  padding: 3px 6px;
  border-radius: 4px;
  width: fit-content;
}

.coupon_label_systemred {
  background-color: var(--systemred-color-5);
}

.coupon_label_secondary {
  background-color: var(--secondary-color-9);
}
</style>



// WEBPACK FOOTER //
// src/components/ai/label/CouponLabel.vue